'use client';

import * as React from 'react';
import { useLocalParticipant } from '@livekit/components-react';
import toast from 'react-hot-toast';
import { raisedHandsToNotify } from '@/lib/raise-hand';
import { identitiesNewlyRaised, playRaiseHandChime } from '@/lib/raise-hand-sound';
import { useRaisedHandQueue } from '@/lib/useRaiseHand';
import { ru } from '@/lib/ru';

export function RaiseHandChime() {
  const queue = useRaisedHandQueue();
  const { localParticipant } = useLocalParticipant();
  const previous = React.useRef<string[] | null>(null);

  React.useEffect(() => {
    const next = queue.map((entry) => entry.identity);
    if (previous.current === null) {
      previous.current = next;
      return;
    }

    const pending = raisedHandsToNotify(previous.current, queue, localParticipant.identity);
    for (const entry of pending) {
      const toastId = `hand-${entry.identity}-${entry.raisedAt}`;
      toast.custom(
        () => (
          <button type="button" className="agima-chat-toast" onClick={() => toast.dismiss(toastId)}>
            <span className="agima-chat-toast-label">{ru.handRaisedToast}</span>
            <span className="agima-chat-toast-name">{entry.name}</span>
          </button>
        ),
        { id: toastId, duration: 4000 },
      );
    }

    if (identitiesNewlyRaised(previous.current, next).length > 0) {
      void playRaiseHandChime();
    }
    previous.current = next;
  }, [queue, localParticipant.identity]);

  return null;
}
